export default class Validate {
    constructor(form) {
        this.form = $(form);
        this.inputs = this.form.find('input, select, textarea');
        this.required = this.form.find('[data-required]');
        this.maskedIinput = this.inputs.filter('.js-mask');
        this.requiredGroup = this.form.find('[data-required-group]');
        this.email = this.form.find('[data-email]');
        this.minlength = this.form.find('[data-minlength]');
        this.fileformat = this.form.find('[data-fileformat]');
        this.submitBtn = this.form.find('[data-submit]');
        this.messages = window.validateMessages || {
            required: 'Это поле обязательно',
            minlength: 'Минимум %min% символов',
            email: 'Неверный формат поля',
            fileformat: 'Недопустимый тип файла'
        };

        /**
            Так как могут быть поля обязательные,
            но ещё не проверенные, приходится вводить
            для них дополнительный класс
        */
        this.form.find('[data-required]').not(':checkbox').not('._no-empty').addClass('_notvalidated');
        this.form.find('[data-required-group]').addClass('_notvalidated');

        this.handleChange();

        this.form.find('._focused input').trigger('change');
    }



    handleChange() {

        if (this.inputs.filter('.js-mask').length) {
            let _this = this;

            if (!App.mobile) {
                this.maskedIinput
                    .filter('[data-inputmask-alias="datetime"]')
                    .inputmask({
                        showMaskOnHover: false
                    });
            } else {
                this.maskedIinput
                    .filter('[data-inputmask-alias="datetime"]')
                    .attr('type', 'date');
            }

            this.inputs.filter('.js-mask').inputmask({
                showMaskOnHover: false,
                onincomplete: function (e) {
                    $(e.currentTarget).addClass('_error');
                    _this.calculateErrors();
                },
                oncomplete: function (e) {
                    $(e.currentTarget).removeClass('_error');
                    _this.calculateErrors();

                    if (typeof $(e.currentTarget).data('autocomplete') != "undefined") {
                        _this.form.submit();
                    }
                }
            });
        }

        /* Если поле с номером телефона, то при фокусе проставляем знак + */
        this.inputs.filter('[data-phone]').on('focus', function() {
            if ($(this).val().length === 0) {
                $(this).val('+');
            }
        });

        /* Если поле с номером телефона, то при потере фокусе если в поле только один символ, то очищаем поле  */
        this.inputs.filter('[data-phone]').on('blur', e =>  {
            let _input = $(e.currentTarget);

            if (_input.val().length === 1) {
                _input.val('').closest('.js-input-wrap').removeClass('_focused');
            }
        });

        /* При вводе в поле типа телефон разрешаем ввод только цифр */
        this.inputs.filter('[data-phone]').on('input', e => {
            const _input = $(e.currentTarget);
            const val = _input.val().replace(/[^0-9]/g, '');
            _input.val(`+${val}`);

            if (App.H.hasClass('ie')) {
                _input.trigger('change');
            }
        });

        this.inputs.filter('[type=date]').on('blur', e => {
            const $input = $(e.target);

            this.validateDate($input);
        });

        this.inputs.on('change', e => {
            const $input = $(e.target);

            // Запускаем проверки
            if ( $input.is(':checkbox[data-required]') ) {
                this.validateRequiredCheckbox($input);
            } else if ( $input.is('[data-required]') ) {
                this.validateRequired($input);
            }

            if ( $input.is('[type=date]') ) {
                this.validateDate($input);
            }

            if ( $input.is('[data-number]') ) {
                this.validateNumber($input);
            }

            if ( $input.is('[type=email]') || $input.is('[data-email]') ) {
                this.validateEmail($input);
            }

            if ( $input.hasClass('js-pass') ) {
                this.validatePassword($input.closest('.js-validate-form'));
            }

            if ( $input.is('[data-minlength]') ) {
                this.validateMinLength($input);
            }

            if ( $input.is('[data-fileformat]') ) {
                this.validateFileFormat($input);
            }

            if ( $input.is('[data-phone]') ) {
                this.validatePhone($input);
            }

            if ( $input.is('[data-required-group]') ) {
                this.validateRequiredGroup($input);
            }

            /**
                Теперь поле либо валидно, либо у него
                есть класс _error, и ложной разблокировки
                кнопки сабмита не будет
            */
            $input.removeClass('_notvalidated');


            // Считаем ошибки
            this.calculateErrors();
        });
    }



    validateRequired($input) {
        // Проверяем обязательные поля

        const $label = $input.siblings('[data-label]');
        const val = $input.val().replace(/\s/g, '');

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length > 0) {
            $input.removeClass('_error').addClass('_focused');
            $label.text('');
        } else {
            $input.addClass('_error').removeClass('_error-ajax _focused');
            $label.text(this.messages.required);
        }
    }



    validateRequiredGroup($input) {
        /**
            Проверяем группу чекбоксов, где хотя бы один
            должен быть отмечен
        */
        const $group = this.form.find(`[name="${$input.attr('name')}"]`);
        let checked = 0;

        $group.each(function() {
            if ( $(this).is(':checked') ) {
                checked++;
            }

            $(this).removeClass('_notvalidated');
        });

        /**
            На всю группу нужен только один маркер _error,
            поэтому добавляем его только первому элементу
        */
        if (checked > 0) {
            $group.eq(0).removeClass('_error');
        } else {
            $group.eq(0).addClass('_error');
        }
    }



    validateRequiredCheckbox($input) {
        // Проверяем обязательные чекбоксы

        if ($input.is(':checked')) {
            $input.removeClass('_error');
        } else {
            $input.addClass('_error');
        }
    }



    validateMinLength($input) {
        // Проверяем минимальное количество символов

        const $label = $input.siblings('[data-label]');
        const min = $input.data('minlength');
        const val = $.trim( $input.val() );

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length >= min) {
            // Достаточно символов

            $input.removeClass('_error');
            $label.text('');

        } else if (val.length > 0) {
            // Недостаточно символов

            const message = this.messages.minlength.replace('%min%', min);

            $input.addClass('_error').removeClass('_error-ajax');
            $label.text(message);

        } else if ( val.length == 0 && $input.is(':not([data-required])') ) {
            // Поле пустое и необязательное

            /**
                Если оно обязательное, в этом случае за него
                будет отвечать validateRequired()
            */

            $input.removeClass('_error');
            $label.text('');
        }
    }

    validatePassword (_form) {
        // Проверяем, что заполенно 2 поля пароля и они совпадают
        let $pass1 = _form.find('.js-pass').eq(0);
        let $pass2 = _form.find('.js-pass').eq(1);

        $pass1.removeClass('_no-empty');
        $pass2.removeClass('_no-empty');

        if ($pass1.val().length >= parseInt($pass1.data('length'))) {
            $pass1.removeClass('_error');

            if ($pass1.val().length > 0 && $pass2.val().length > 0 && $pass1.val() === $pass2.val()) {
                $pass1.closest('.js-input-wrap').addClass('_ok');
                $pass2.closest('.js-input-wrap').addClass('_ok');
                _form.attr('data-save', _form.data('save-text'));
            } else {
                //$pass1.closest('.js-input-wrap');
                $pass2.addClass('_error').closest('.js-input-wrap').removeClass('_ok');
                _form.removeAttr('data-save');
            }
        } else {
            $pass1.addClass('_error');
        }
    }

    /* Проверяем чтобы возраст был больше заданного кол-ва лет */
    checkAge(val, minVal) {
        let currYear = ((new Date().getTime() - new Date(val)) / (24 * 3600 * 365.25 * 1000)) | 0;

        return currYear >= minVal;
    }

    validatePhone($input) {
        const val = $input.val().replace('+', '');

        if (!val.length) {
            $input.addClass('_error');
            return;
        }

        if (!$.isNumeric(val) || ($input.attr('maxlength').length && val.length > parseInt($input.attr('maxlength')))) {
            $input.addClass('_error').removeClass('_error-ajax');
        } else {
            $input.removeClass('_error');
        }

        this.calculateErrors();
    }

    validateDate($input) {
        let dateVal = $input.val();

        if (dateVal.length === 0) {
            $input.removeClass('_error');
            return;
        }

        dateVal = dateVal.replace(/\./g, "/");

        if (new Date(dateVal) == 'Invalid Date') {
            $input.addClass('_error');
        } else {
            $input.removeClass('_error');

            // если дата валидная и задано минимальное кол-во лет, то проверяем что возраст подходит под эту дату
            if ($input.data('age')) {
                if (this.checkAge(dateVal, $input.data('age'))) {
                    $input.removeClass('_error');
                } else {
                    $input.addClass('_error');
                }
            }
        }
    }

    validateNumber($input) {
        //const $label = $input.siblings('[data-label]');
        const val = $input.val().replace(/\s/g, '');

        /**
             Если поле пустое, то не валидируем его,
             оставляем эту работу для validateRequired()
         */

        if (!val.length) return;

        if (!$.isNumeric(val) || ($input.attr('maxlength').length && val.length > parseInt($input.attr('maxlength')))) {
            $input.addClass('_error').removeClass('_error-ajax');
        } else {
            $input.removeClass('_error');
            //$label.text('');
        }
    }


    validateEmail($input) {
        // Проверяем email

        const $label = $input.siblings('[data-label]');
        const val = $input.val().replace(/\s/g, '');

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length) return;


        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (/^[a-z0-9](\.?[a-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i.test(val)) {
            $input.removeClass('_error');
            $label.text('');
        } else {
            $input.addClass('_error').removeClass('_error-ajax');
            $label.text(this.messages.email);
        }
    }



    validateFileFormat($input) {
        // Проверяем расширение файла

        const $label = $input.siblings('[data-label]');
        const accept = $input.attr('accept').split(',');
        const val = $input.val();

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length) return;


        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        const ext = '.' + val.split('.').pop();

        if ( $.inArray(ext, accept) > -1 ) {
            $input.removeClass('_error');
            $label.text('');
        } else {
            $input.addClass('_error');
            $label.text(this.messages.fileformat);
        }
    }



    calculateErrors() {
        // Подводим итоги проверок

        const errors = this.form.find('._error, ._notvalidated').length;

        /**
            Считаем ошибки в форме,
            и блокируем или разблокируем
            кнопку сабмита
        */

        /*if (errors > 0) {
            this.submitBtn.attr('disabled', true);
        } else {
            this.submitBtn.removeAttr('disabled');
        }*/

        return errors === 0;
    }
}



// WEBPACK FOOTER //
// ./_src/js/modules/Validate.js